<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    @let welcome = welcomeMessage();
    <ion-title>{{ welcome.key | translate: welcome.params }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-16">
    @if (profile(); as profile) {
      <work-ui-montageplan-personal-planning-overview [userId]="profile.id"
                                                      [fromDate]="dayjs().format('YYYY-MM-DD')"
                                                      [toDate]="toDate()"
                                                      [hideSundaysAndEmptySaturdays]="true"
                                                      (openProjectDetails)="openProjectDetails($event)"
                                                      (openUserDetails)="openUserDetails($event)" />
    }
  </div>
</ion-content>
